<template>
  <b-alert show variant="primary" style="padding:0.5em; margin:0.5em;">
    <h3>Welcome {{displayName}}!</h3>
    <hr>

    <div v-if="participantSufficientInfo.privilegesParticipant && !participantSufficientInfo.statusPrivacy">
      <p>We are the ORBITA-2 researchers, based at Imperial College London, United Kingdom. We need your permission to store information about you.
      </p>

      <h5>What we store and why</h5>
      <p>Your name, email and phone numbers, so we can contact you and you can log in.<br>
        Your symptom answers, to analyse for the trial.</p>

      <h5>How long for?</h5>
      <p>Your name and contact details will be deleted when you finish the trial, or earlier if you ask. After that, our system will keep only your anonymous symptom answers. Symptom answers from all participants will be the main result of the ORBITA-2 trial, which will be published to help treat future patients with angina.<br>Later, we may make the anonymous symptom answers publicly available so that researchers around the world can check our findings and build upon them.
      </p>

      <h5>Your rights</h5>
      <p>You have a right to a copy of your data, and a right to have it deleted from our system. You can exercise these rights by contacting our administrator Juliet Holmes on 0207 594 5735.</p>

      <h5>We need your permission</h5>
      <p> Do you allow us to store and process your information as described above?</p>
      <div style="display:flex; flex-direction:row; justify-content:space-evenly;">
        <b-button size="lg" variant="primary" v-on:click="$emit('gave-permission');">&nbsp; &nbsp; Yes &nbsp; &nbsp;</b-button>
        <b-button size="lg" variant="danger" v-on:click="$emit('refused-permission')">&nbsp; &nbsp; No &nbsp; &nbsp;</b-button>
      </div>
      <br>
    </div>

    <div v-else>
      <h4>Now the researcher will finish setting up your details:</h4>
      <ul>
        <li v-if="!participantSufficientInfo.privilegesParticipant"> That you are joining the trial</li>
        <li v-if="!participantSufficientInfo.contactShortName"> Short name or nickname</li>
        <li v-if="!participantSufficientInfo.contactStartDateKey"> Starting date</li>
        <li v-if="!participantSufficientInfo.contactMyAnginaIs"> Your own description of your angina</li>
        <li v-if="!participantSufficientInfo.contactWindowQuestions"> Activities causing angina</li>
      </ul>
    </div>

  </b-alert>
</template>

<script>
export default {
  props: {
    displayName: String,
    participantSufficientInfo: Object
  }
};
</script>

<style>
</style>





// WEBPACK FOOTER //
// src/components/AppPrivacy.vue